"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    currentId: {
      type: Number,
      default: 0
    },
    refreshData: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      isVisible: false,
      formLabelWidth: '120px',
      listLoading: false,
      list: [],
      total: 0,
      currPage: 1,
      limit: 10,
      multipleSelection: [],
      searchVal: {
        interfaceNo: '',
        interfaceName: ''
      }
    };
  },
  watch: {
    isShow: function isShow(val) {
      this.isVisible = val;
      if (this.isVisible) {
        this.fetchData();
      }
    }
  },
  mounted: function mounted() {
    // this.fetchData()
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this = this;
      var params = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          interfaceNo: this.searchVal.interfaceNo,
          interfaceName: this.searchVal.interfaceName
        }
      };
      this.listLoading = true;
      this.$api.interfaceuser.authInfosInterfaceUser(this.currentId, params).then(function (res) {
        _this.listLoading = false;
        _this.list = res.data.items;
        _this.total = res.data.totalCount;
        _this.$nextTick(function () {
          _this.list.forEach(function (row) {
            if (row.checked === 'Y') {
              _this.$refs.dataTable.toggleRowSelection(row, true);
            } else {
              _this.$refs.dataTable.toggleRowSelection(row, false);
            }
          });
        });
      }).catch(function () {
        _this.listLoading = false;
        console.log('Data Request Fail');
      });
    },
    clickCloseBtn: function clickCloseBtn(done) {
      this.resetTable();
    },
    clickSave: function clickSave() {
      var _this2 = this;
      // this.$emit('dialogHidden')
      var interfaceNos = [];
      for (var i = 0; i < this.multipleSelection.length; i++) {
        interfaceNos.push(this.multipleSelection[i].interfaceNo);
      }
      var param = {
        userPk: this.currentId,
        interfaceNos: interfaceNos
      };
      this.$api.interfaceuser.authSaveInterfaceUser(param).then(function (res) {
        _this2.resetTable();
        _this2.refreshData();
      }).catch(function () {
        // this.$message.error('保存失败')
      });
    },
    clickCancel: function clickCancel() {
      this.resetTable();
    },
    resetTable: function resetTable() {
      this.$emit('dialogHidden');
      this.currPage = 1;
      this.limit = 10;
      this.$refs.dataTable.clearSelection();
    },
    formatterState: function formatterState(row, column) {
      if (row.state === 'ENABLE') {
        return this.$t('common.ENABLE');
      } else if (row.state === 'DISABLED') {
        return this.$t('common.DISABLED');
      }
      return row.state;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getRowKeys: function getRowKeys(row) {
      return row.interfaceNo; // id为列表数据的唯一标识
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    }
  }
};